import React from 'react';
import { GraduationCap, BookOpen, Award, Clock, Users } from 'lucide-react';
import { AppBar } from '../../ui';

const Dashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header — shared platform AppBar (h-12, the only gradient in the system) */}
      <AppBar icon={<GraduationCap className="h-4 w-4 text-white" />} toolName="LMS" />

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 dark:bg-primary-900/30 rounded-full mb-6">
            <GraduationCap size={40} className="text-primary-600 dark:text-primary-400" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">Learning Center</h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Training and certification management for clinical research staff.
            Complete required trainings, track certifications, and stay compliant.
          </p>
        </div>

        {/* Coming Soon Features */}
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-8 mb-8">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-6">Coming Soon</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                <BookOpen size={20} className="text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900 dark:text-gray-100">Required Trainings</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">ICH GCP, HIPAA, IT Security, Bloodborne Pathogens, and more</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
                <Award size={20} className="text-green-600 dark:text-green-400" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900 dark:text-gray-100">Certifications</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">Track and manage staff certifications with expiration alerts</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-purple-100 dark:bg-purple-900/30 rounded-lg flex items-center justify-center">
                <Clock size={20} className="text-purple-600 dark:text-purple-400" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900 dark:text-gray-100">SOP Training</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">Site-specific SOP training with acknowledgment tracking</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-orange-100 dark:bg-orange-900/30 rounded-lg flex items-center justify-center">
                <Users size={20} className="text-orange-600 dark:text-orange-400" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900 dark:text-gray-100">Platform Training</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">Learn how to use SiteOperations.io tools effectively</p>
              </div>
            </div>
          </div>
        </div>

        {/* Status Banner */}
        <div className="bg-primary-50 border border-primary-200 dark:bg-primary-900/20 dark:border-primary-800 rounded-lg p-6 text-center">
          <p className="text-primary-800 dark:text-primary-300">
            <span className="font-semibold">This module is under development.</span>
            {' '}Check back soon for updates or contact your administrator for more information.
          </p>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
